export default __webpack_public_path__ + "static/media/ZA.da673cd6.svg";